import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  EmailAddressDialog,
  EmailAddressDialogCallbackInput,
  EmailAddressUniqueProps,
} from '../EmailAddressDialog';

const { useDialogForContext, useDialog: useEmailAddressDialog } =
  getDialogHooks<EmailAddressUniqueProps, EmailAddressDialogCallbackInput>(
    EmailAddressDialog
  );
export const useEmailAddressDialogForContext = useDialogForContext;
export default useEmailAddressDialog;
